import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import styles from './index.module.scss'
import { PrimaryHeading } from '../../atoms/PrimaryHeading'
import { ICompanyBase } from '../../../types'
import { ProfileCard } from '../../molecules/ProfileCard'
import { getUserAvatar } from '../../../utils'
import { NoContent } from '../../atoms/NoContent'

type Props = {
  company: ICompanyBase
}

export const CompanyProfileMember: FC<Props> = ({ company }) => {
  const { t } = useTranslation(['companies-[id]'])
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <PrimaryHeading backgroundText='MEMBER' htmlTagType='h2'>
          {t('メンバー')}
        </PrimaryHeading>
      </div>
      <div className={styles.content}>
        {company?.companyMembers.length === 0 ? (
          <NoContent>{t('メンバーがまだ登録されていません。')}</NoContent>
        ) : (
          <div className={styles.cardList}>
            {company.companyMembers.map((member) => {
              return (
                <div key={member.user.username} className={styles.cardItem}>
                  <ProfileCard
                    avatar={getUserAvatar(member.user)}
                    name={member.user.name}
                    href={`/users/${member.user.username}`}
                    isVerifiedAccount={member.user.profile.isVerifiedAccount}
                  >
                    <p className={styles.text}>{member.user.profile.bio}</p>
                  </ProfileCard>
                </div>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}
